import { put, takeLatest } from 'redux-saga/effects';
import throwInServerSideRendering from '@dbh/throw-in-server-side-rendering';
import { DAEMON } from '@dbh/redux-extra';
import 'prop-types';
import { replace } from 'react-router-redux';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import { F as FRONT_END_LOGIC_REDIRECT_TRIGGERED, R as REDUX_AND_SAGA_KEY } from './index-5b1a6080.js';
import '@dbh/environment';
import '@dbh/generic-types';

const fnName="handleFrontEndLogicRedirectInBrowser",handleFrontEndLogicRedirectInBrowser=withConformsTo("handleFrontEndLogicRedirectInBrowser",[],function*(a){throwInServerSideRendering(fnName);const{payload:{redirectTo:b,redirectLogic:c}}=a;yield put(replace(b));});/**
 * Executes a front end logic redirect in the browser. This saga doesn't run
 * in server side rendering, because in that case, we execute the redirect
 * at the end of the server rendering process, after selecting the redirect data
 * from the reducer of `@dbh/front-end-logic-redirect-redux`.
 * @param {Object} event .
 * @param {string} event.type .
 * @param {Object} event.payload .
 * @param {string} event.payload.redirectTo .
 * @param {string} event.payload.redirectLogic .
 * @param {number?} event.payload.statusCode .
 */var handleFrontEndLogicRedirectInBrowser$1 = handleFrontEndLogicRedirectInBrowser;

function*frontEndLogicRedirectSaga(){throwInServerSideRendering("frontEndLogicRedirectSaga"),yield takeLatest(FRONT_END_LOGIC_REDIRECT_TRIGGERED,handleFrontEndLogicRedirectInBrowser$1);}const injectedSagaConfiguration={key:REDUX_AND_SAGA_KEY,mode:DAEMON};

export { frontEndLogicRedirectSaga as default, injectedSagaConfiguration };
